import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Gift, ShieldCheck } from "lucide-react";

function ConsentModal({ c, onClose, onConfirm }) {
  const [ok, setOk] = useState(false);
  return (
    <div className="fixed inset-0 z-[80] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="sponsor-consent-modal">
      <div className="rl-card p-6 max-w-md w-full" onClick={e => e.stopPropagation()}>
        <div className="pill-badge pill-amber mb-2"><ShieldCheck className="w-3 h-3" /> CREDITI OFFERTI DA {c.sponsor.toUpperCase()}</div>
        <h3 className="font-display font-black text-2xl mb-2">{c.credits} Rally Credits in regalo</h3>
        <p className="text-sm text-slate-300 mb-4" data-testid="sponsor-consent-text">{c.consent_text}</p>
        <label className="flex items-start gap-2 text-sm cursor-pointer mb-5"><input type="checkbox" checked={ok} onChange={e => setOk(e.target.checked)} className="mt-1 w-5 h-5 accent-[#FF1E27]" data-testid="sponsor-consent-checkbox" /> <span>Ho letto e accetto: nessun dato personale viene trasmesso a {c.sponsor}.</span></label>
        <div className="flex gap-2 flex-wrap"><button className="btn-crimson !py-2 !px-5 text-xs min-h-[44px]" disabled={!ok} onClick={() => onConfirm()} data-testid="sponsor-consent-confirm">RISCATTA {c.credits} RC</button><button className="btn-outline-rl !py-2 !px-5 text-xs min-h-[44px]" onClick={onClose} data-testid="sponsor-consent-cancel">ANNULLA</button></div>
      </div>
    </div>
  );
}

export default function CreditClaims({ rallyId }) {
  const { user } = useAuth();
  const [claims, setClaims] = useState([]);
  const [modal, setModal] = useState(null);
  const load = () => { if (user) axios.get(`${API}/credits/claims/${rallyId}`).then(r => setClaims(r.data)).catch(() => {}); };
  useEffect(load, [rallyId, user]);
  const open = claims.filter(c => !c.claimed);
  if (!user || !open.length) return null;
  const claim = async (c, consent = false) => {
    if (c.kind === "SPONSOR" && !consent) { setModal(c); return; }
    try { await axios.get(`${API}/credits/wallet`); const { data } = await axios.post(`${API}/credits/claims/${rallyId}/${c.code}`, { consent }); toast.success(`+${data.credits} Rally Credits accreditati`); setModal(null); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="mt-4 flex flex-wrap gap-2" data-testid="credit-claims">
      {open.map(c => <button key={c.code} onClick={() => claim(c)} data-testid={`claim-${c.code}`} className="rl-card px-4 py-2 text-xs flex items-center gap-2 min-h-[44px] hover:border-[#FF9F0A]"><Gift className="w-4 h-4 text-[#FF9F0A]" /> {c.credits} RC {c.sponsor ? `offerti da ${c.sponsor}` : "bonus Paddock"} · RISCATTA</button>)}
      {modal && <ConsentModal c={modal} onClose={() => setModal(null)} onConfirm={() => claim(modal, true)} />}
    </div>
  );
}
